import React from 'react'
import PropType from 'prop-types'
import { Rate } from '@cred/react-rate'
import Font from '@cred/react-font'
import querystring from 'querystring'
import pickby from 'lodash.pickby'
import identity from 'lodash.identity'
import { LendersText } from '@cred/react-marketing'
import config from 'config'
import CtaButton from 'components/cta-button'
import PoweredBy from 'components/powered-by'
import { AdvertiserDisclosure } from 'components/advertiser-disclosure'
import styles from './styles.scss'

const minimumFixedPersonalApr = {
  rateType: 'apr',
  vertical: 'personal',
  variable: false,
  name: 'min',
  lenderSlug: null,
}

// eslint-disable-next-line
export const generateClickUrl = ({ utm_campaign, utm_source, utm_medium, utm_content }) => {
  const utmParams = pickby({
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
  }, identity)

  return `${config.credibleRoot}/personal-loans/borrower?${querystring.encode(utmParams)}`
}

const PersonalAnimatedCta = ({ utms }) => (
  <div className={styles.container}>
    <AdvertiserDisclosure />
    <div className={styles.root}>
      <div>
        <Font element="h2" type="medium" weight="bold" className={styles.mainHeader}>Personal loans for all<br />your financial needs</Font>
        <Font type="bodySmall" element="h3" className={styles.lendersTextWrapper}>
          <LendersText
            startText="Rates from up to"
            endText="lenders starting at"
            defaultText="Rates from our many lenders starting at"
            vertical="personal_loans"
          />
        </Font>
        <h3 className={styles.aprWrapper}>
          <Font
            element="span"
            type="inherit"
            color="secondary"
            className={styles.rateWrapper}
          >
            <Rate graphql {...minimumFixedPersonalApr} />
          </Font>
          <Font element="span" type="bodySmall">
            APR
          </Font>
        </h3>
        <div className={styles.mobileCarousel} />

        <CtaButton
          href={generateClickUrl(utms)}
          fullWidth
          blank
        >
          Compare Rates
        </CtaButton>
        <PoweredBy className={styles.poweredBy} />
      </div>
      <div className={styles.tabletCarousel} />
    </div>

  </div>
)


PersonalAnimatedCta.propTypes = {
  utms: PropType.object,
}

export default PersonalAnimatedCta
